// index.js
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // 只导入 Router
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import thTH from 'antd/locale/th_TH';
import App from './App';
import './index.css'; // 全局样式
import './styles/redesign.css'; // 改版样式（信息架构 / 门户 / 登录 / 面板）
import i18n from './i18n'; // i18n 国际化配置

// 按当前语言为 antd 组件提供对应 locale
const AppWithLocale = () => {
  const [lang, setLang] = useState(i18n.language);

  useEffect(() => {
    const handler = (lng) => setLang(lng);
    i18n.on('languageChanged', handler);
    return () => { i18n.off('languageChanged', handler); };
  }, []);

  const locale = lang && lang.startsWith('th') ? thTH : lang && lang.startsWith('en') ? enUS : zhCN;

  return (
    <ConfigProvider locale={locale}>
      {/* 在这里提供路由环境，App.js 及其子组件都能使用 useNavigate */}
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ConfigProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AppWithLocale />
  </React.StrictMode>
);
